import { Link, useLocation } from "react-router-dom";
import { LayoutGrid, CalendarDays, BookMarked } from "lucide-react";
import { Group, Box } from "@mantine/core";

const tabs = [
  { to: "/meeting-rooms", label: "Rooms", icon: LayoutGrid, exact: false },
  { to: "/meeting-rooms/timeline", label: "Timeline", icon: CalendarDays, exact: true },
  { to: "/my-bookings", label: "My Bookings", icon: BookMarked, exact: false },
] as const;

export function MeetingNav() {
  const { pathname } = useLocation();

  function isActive(to: string, exact: boolean) {
    if (exact) return pathname === to;
    if (to === "/meeting-rooms") return pathname === "/meeting-rooms" || pathname.startsWith("/meeting-rooms/") && !pathname.startsWith("/meeting-rooms/timeline");
    return pathname.startsWith(to);
  }

  return (
    <Group
      gap={0}
      mb="md"
      style={{ borderBottom: "1px solid var(--mantine-color-default-border)" }}
    >
      {tabs.map(({ to, label, icon: Icon, exact }) => {
        const active = isActive(to, exact);
        return (
          <Box
            key={to}
            component={Link}
            to={to}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              padding: "10px 16px",
              fontSize: "var(--mantine-font-size-sm)",
              fontWeight: 500,
              textDecoration: "none",
              borderBottom: "2px solid",
              marginBottom: -1,
              transition: "color 150ms, border-color 150ms",
              borderColor: active
                ? "var(--mantine-primary-color-filled)"
                : "transparent",
              color: active
                ? "var(--mantine-primary-color-filled)"
                : "var(--mantine-color-dimmed)",
            }}
          >
            <Icon size={16} />
            {label}
          </Box>
        );
      })}
    </Group>
  );
}
